<template>
  <a-result
    :status="errorType"
    title="Sorry, something is wrong with our server"
  >
    <template #extra>
      <a-button type="primary" @click="handleBtnBack">
        Tilbake Hjem
      </a-button>
    </template>
  </a-result>
</template>

<script>
export default {
  props: {
    errorType: { type: String }
  },
  data() {
    return {
      title: "",
      message: ""
    };
  },
  methods: {
    handleBtnBack() {
      this.$router.push("/");
    }
  },
  created() {}
};
</script>
